export default __webpack_public_path__ + "static/media/loader.5127cea7.gif";